import { Button, HFlow, Modal, ModalBody, ModalFooter, ModalHeader, Text } from 'bold-ui'

interface ConfirmarModalProps {
  closeModal(): void
  onClickConfirmarCidadao(): void
  open: boolean
  children: any
}

export default function ConfirmarModal({ closeModal, onClickConfirmarCidadao, open, children }: ConfirmarModalProps) {
  return (
    <Modal onClose={closeModal} open={open} style={{ width: '40rem' }}>
      <ModalHeader title='Deseja unificar os cadastros?' icon={{ name: 'questionMarkFilled', fill: 'info' }} />
      <ModalBody>
        <Text data-cy='Mensagem'>{children}</Text>
      </ModalBody>
      <ModalFooter>
        <HFlow justifyContent='flex-end'>
          <Button kind='normal' size='medium' onClick={closeModal}>
            Cancelar
          </Button>
          <Button
            kind='primary'
            skin='default'
            size='medium'
            onClick={onClickConfirmarCidadao}
            data-cy='ContinuarButton'
          >
            Continuar
          </Button>
        </HFlow>
      </ModalFooter>
    </Modal>
  )
}
